import { useAuth } from '@/contexts/AuthContext';
import { TIER_LIMITS, SubscriptionTier, TierFeature } from '@/config/tierConfig';

export function useTierGate() {
  const { profile } = useAuth();

  const tier = (profile?.subscription_tier ?? 'free') as SubscriptionTier;
  const limits = TIER_LIMITS[tier];
  const isPlus = tier !== 'free';

  const canAccess = (feature: TierFeature): boolean => {
    const value = limits[feature];
    if (typeof value === 'boolean') return value;
    if (value === null) return true;
    if (value === 'all') return true;
    return false;
  };

  const isAtContactLimit = (currentCount: number): boolean => {
    if (limits.maxContacts === null) return false;
    return currentCount >= limits.maxContacts;
  };

  const isAtMessageLimit = (monthlyCount: number): boolean => {
    if (limits.aiMessagesPerMonth === null) return false;
    return monthlyCount >= limits.aiMessagesPerMonth;
  };

  const canUseOccasionType = (occasionType: string): boolean => {
    if (limits.occasionTypes === 'all') return true;
    return (limits.occasionTypes as string[]).includes(occasionType);
  };

  const contactLimit = limits.maxContacts;
  const messageLimit = limits.aiMessagesPerMonth;

  return {
    tier,
    limits,
    isPlus,
    canAccess,
    isAtContactLimit,
    isAtMessageLimit,
    canUseOccasionType,
    contactLimit,
    messageLimit,
  };
}
